import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { finalize, tap } from 'rxjs/operators';
import { encryptData, decryptData } from './utilities';
import { BaseComponents } from '../base.component';
import { environment } from 'src/environments/environment';
import * as uuid from 'uuid';
import { ReferenceService } from '../services/reference.service';


function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode(parseInt(p1, 16))
  }))
}


@Injectable()
export class EncryptInterceptor extends BaseComponents implements HttpInterceptor {
  constructor(
    protected injectorObj:Injector,
    private referenceService: ReferenceService
    //private logger: NGXLogger
  ) {
    super(injectorObj);
  }
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const startTime = Date.now();
    let status: string;
    let body: any = null
    //req.body['ggg']="เต๋า"
    let params = req.body
    // console.log("inercetion param", params);
    // console.log("========================= intersceptor")
    let timeout = encryptData(b64EncodeUnicode(JSON.stringify(new Date().getTime() + 3500))); //ไส่ timeout 3.5 วิ
    let data = encryptData(b64EncodeUnicode(JSON.stringify(req.body || {})))
    let payload: HttpRequest<any>;
    // if ((environment.mode !== 'alpha') && (environment.mode === 'beta' && environment.sub_state ==='state3')) {
    // if(!(environment.mode == 'beta' && environment.sub_state == 'state2') && false){ 
    //   payload = req.clone({ body: { data: data + '[t]' + timeout } })
    // }else{
    //   payload = req.clone()
    // }

    let router: Router | null = null;
    try {
      router = this.injectorObj.get(Router);
    } catch (error) {
      router = null;
    }

    let currentPath = '/';
    if (router && router.url) {
      currentPath = router.url.split('?')[0].split('#')[0];
    }

    const sessionUuid = this.referenceService.getReferenceUUID();
    const logSessionId = sessionUuid;
    const flowSessionId = sessionUuid + ':' + currentPath;

    let token: any = {
      log_session_id: logSessionId,
      flow_session_id: flowSessionId,
      ref_id: logSessionId,
    };

    let headers = {
      'app-meta': JSON.stringify(token || {}) //encrypt(JSON.stringify(token || {}))
    }

    payload = req.clone({ setHeaders: { ...headers } })

    //this.logger.debug("payload interception: ", payload)
    //req
    return next.handle(payload).pipe(
      tap(
        event => {
          status = '';
          if (event instanceof HttpResponse) {
            status = 'succeeded';
            body = event.body
          }
        },
        error => status = 'failed'
      ),
      finalize(() => {
        const elapsedTime = Date.now() - startTime;
        const message = req.method + " " + req.urlWithParams + " " + status
          + " in " + elapsedTime + "ms";

        // this.logger.debug('Url',message);
        // this.logger.debug('Request',params);
        // this.logger.debug('Response',body);

      })
    );
  }
  private logDetails(msg: any) {
    //this.logger.debug(msg);
  }
}

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: EncryptInterceptor, multi: true }
]; 